export const getIdNumber = (val) => {//获取证件号码
  console.log(val, '000')
  if (!val.cardType || val.cardType == 1 || val.cardType == 'NI') {
    return val.cardNo
  } else if (val.cardType == 2 || val.cardType == 'B' || val.cardType == 'PP') {
    return val.cardNo
  } else {
    return val.cardNo
  }
}

export const getIdType = (val) => {//获取证件类型
  console.log('000', val)
  if (!val.cardType || val.cardType == 1 || val.cardType == 'NI') {
    return 'NI'
  } else if (val.cardType == 2 || val.cardType == 'B' || val.cardType == 'PP') {
    return 'PP'
  } else if (val.cardType == 'GA') {
    return 'GA'
  } else if (val.cardType == 'TW') {
    return 'TW'
  } else if (val.cardType == 'TB') {
    return 'TB'
  } else if (val.cardType == 'HX') {
    return 'HX'
  } else if (val.cardType == 'HY') {
    return 'HY'
  } else if (val.cardType == 'HR') {
    return 'HR'
  } else if (val.cardType == 'JR') {
    return 'JR'
  } else if (val.cardType == 'BC') {
    return 'BC'
  } else if (val.cardType == 'FI') {
    return 'FI'
  } else if (val.cardType == 'HM') {
    return 'HM'
  } else {
    return 'ID'
  }
}
export const getName = (val) => {//获取出行人名称
  if (val.clkFlag == 1 || val.chName) {
    return val.chName
  } else if (val.cxrName) {
    return val.cxrName
  } else if (val.psgName) {
    return val.psgName
  } else {
    return val.empName
  }
}
export const setName = (obj, val) => {//赋值出行人名称
  if (obj.clkFlag == 1 || obj.chName) {
    obj.chName = val
  } else if (obj.cxrName) {
    obj.cxrName = val
  } else if (obj.psgName) {
    obj.psgName = val
  } else {
    obj.empName = val
  }
  return obj
}

export const getEmpId = (val) => {//获取出行人ID
  if (val.clkFlag == 1 || val.clkFlag == 0) {
    return val.contactsId
  } else if (val.clkFlag == 2) {//员工
    return val.empId
  }
}
export const getUserInfo = (val, cplx) => {//获取产品权限
  if (val) {
    var vipCorp = val.vipCorp
    var empInfo = val.empInfo
    if (cplx && empInfo.rangeMap && empInfo.rangeMap[cplx]) {
      if (empInfo.rangeMap[cplx].bookOutside) {
        empInfo.bookOutside = empInfo.rangeMap[cplx].bookOutside
      } else if (!empInfo.bookOutside || empInfo.bookOutside !== 0) {
        empInfo.bookOutside = 0
      }
      if (empInfo.rangeMap[cplx].bookRange) {
        empInfo.bookRange = empInfo.rangeMap[cplx].bookRange
      } else if (!empInfo.bookRange || empInfo.bookRange !== 0) {
        empInfo.bookRange = 0
      }
    }
    return {
      'vipCorp': vipCorp,
      'empInfo': empInfo
    }
  }
}

export const getIDcardInfo = (sId) => {//获取产品权限
  //    18位省份证7、8、9、10为出生年份；11、12位为月份；13、14位为日期；第17位为性别，基数为男，偶数为女
  //   正则判断省份、生日、性别
  //    前2位判断省份
  //定义地区数组
  var CityArray = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外'
  }
  if (sId) {
    sId = '' + sId
  } else {
    return
  }
  if (sId.length == 15) {
    sId = sId.replace(/([\d]{6})(\d{9})/, '$119$2x')
  }
  var iSum = 0
  if (!/^\d{17}(\d|x)$/i.test(sId)) return '非法的身份证号'
  sId = sId.replace(/x$/i, 'a')
  if (CityArray[parseInt(sId.substr(0, 2))] == null) return 'Error:非法地区'
  var sBirthday = sId.substr(6, 4) + '-' + sId.substr(10, 2) + '-' + sId.substr(12, 2)
  var d = new Date(sBirthday.replace(/-/g, '/'))
  var m = (d.getMonth() + 1)
  if (m < 10) {
    m = '0' + m
  }
  var dat = (d.getDate())
  if (dat < 10) {
    dat = '0' + dat
  }
  if (sBirthday != (d.getFullYear() + '-' + m + '-' + dat)) return 'Error:非法生日'
  for (var i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11)
  if (iSum % 11 != 1) return 'Error:非法证号'
  //获取年龄
  var myDate = new Date()
  var month = myDate.getMonth() + 1
  var day = myDate.getDate()
  var age = myDate.getFullYear() - sId.substring(6, 10) - 1
  if (sId.substring(10, 12) < month || sId.substring(10, 12) == month && sId.substring(12, 14) <= day) {
    age++
  }

  return {
    success: true,
    provinces: CityArray[parseInt(sId.substr(0, 2))],
    born: sBirthday,
    age: age,
    sex: sId.substr(16, 1) % 2  //1男
  }
}
